import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Download, Loader2, Ban } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";

const trigger = (url) => {
  const a = document.createElement("a");
  a.href = url;
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
};

export const DownloadButton = ({ media, canEdit, onChange }) => {
  const { user } = useAuth();
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);
  const allowed = media.allow_download !== false;

  const download = async () => {
    if (!user) { toast("Sign in to save photos and videos"); nav("/login"); return; }
    setBusy(true);
    try {
      const n = media.is_set ? media.asset_count : 1;
      for (let i = 0; i < n; i++) {
        const { data } = await api.get(`/media/${media.id}/download`, { params: { asset: i } });
        trigger(data.url);
        if (n > 1) await new Promise((r) => setTimeout(r, 500));
      }
      toast.success(n > 1 ? `Saving ${n} files` : "Download started");
    } catch (e) { toast.error(formatApiError(e)); }
    setBusy(false);
  };

  const toggle = async () => {
    try {
      await api.put(`/media/${media.id}/downloads`, { value: !allowed });
      onChange?.(!allowed);
      toast.success(!allowed ? "Downloads turned on" : "Downloads turned off");
    } catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <span className="flex items-center gap-1">
      {(allowed || canEdit) && (
        <button data-testid="download-btn" onClick={download} disabled={busy} title="Save to your device"
          className="flex items-center gap-1.5 px-3 py-2 rounded-full border border-white/10 text-white text-xs hover:border-[#00E5FF] hover:text-[#00E5FF] transition-colors disabled:opacity-50">
          {busy ? <Loader2 size={14} className="animate-spin" /> : <Download size={14} />} Save
        </button>
      )}
      {canEdit && (
        <button data-testid="download-toggle-btn" onClick={toggle} title={allowed ? "Turn off downloads for others" : "Allow others to download"}
          className={`p-2 rounded-full transition-colors ${allowed ? "text-[#52525B] hover:text-[#FF2A5F]" : "text-[#FF2A5F] bg-[#FF2A5F]/10"}`}>
          <Ban size={14} />
        </button>
      )}
    </span>
  );
};
